import pos1 from 'assets/icons/positions/pos-1.png'
import pos2 from 'assets/icons/positions/pos-2.png'
import pos3 from 'assets/icons/positions/pos-3.png'
import pos4 from 'assets/icons/positions/pos-4.png'
import pos5 from 'assets/icons/positions/pos-5.png'
import pos6 from 'assets/icons/positions/pos-6.png'
import pos7 from 'assets/icons/positions/pos-7.png'
import pos8 from 'assets/icons/positions/pos-8.png'
import pos9 from 'assets/icons/positions/pos-9.png'
import pos10 from 'assets/icons/positions/pos-10.png'
import pos11 from 'assets/icons/positions/pos-11.png'
import pos12 from 'assets/icons/positions/pos-12.png'

// Types
import { Option } from 'common/types'
import { HeadCell, TagCategory } from './CardView.types'

export const skinPreps = [
  {
    id: 'betadine5',
    name: 'Betadine 5%',
  },
  {
    id: 'betadine10',
    name: 'Betadine 10%',
  },
  {
    id: 'dilutedBetadine',
    name: 'Diluted Betadine',
  },
  {
    id: 'chloraPrep',
    name: 'Chloraprep',
  },
  {
    id: 'chlorhexidine',
    name: 'Chlorhexidine',
  },
  {
    id: 'PCMX',
    name: '3% PCMX',
  },
]

export const positioningDevices = [
  {
    id: 'gelDonut',
    name: 'Gel Donut',
  },
  {
    id: 'gelRolls',
    name: 'Gel Rolls',
  },
  {
    id: 'other',
    name: 'Others',
  },
]

export const anesthesia = [
  {
    id: 'interscalene',
    name: 'Interscalene',
  },
  {
    id: 'supraclavicular',
    name: 'Supraclavicular',
  },
  {
    id: 'infraclavicular',
    name: 'Infraclavicular',
  },
  {
    id: 'axillary',
    name: 'Axillary',
  },
  {
    id: 'femoral',
    name: 'Femoral',
  },
  {
    id: 'adductorCanal',
    name: 'Adductor Canal',
  },
  {
    id: 'sciatic',
    name: 'Sciatic',
  },
  {
    id: 'popliteal',
    name: 'Popliteal',
  },
  {
    id: 'ankle',
    name: 'Ankle',
  },
]

export const packsOptions: Option[] = [
  { id: 'General', name: 'General' },
  { id: 'ECMO', name: 'ECMO' },
  { id: 'Mini', name: 'Mini' },
  { id: 'Cystoscopy', name: 'Cystoscopy' },
  { id: 'Cataract', name: 'Cataract' },
  { id: 'Eye', name: 'Eye' },
  { id: 'Craniotomy', name: 'Craniotomy' },
  { id: 'VP shunt', name: 'VP shunt' },
  { id: 'L and B', name: 'L and B' },
  { id: 'T and A', name: 'T and A' },
  { id: 'Mastoid', name: 'Mastoid' },
  { id: 'ENT', name: 'ENT' },
  { id: 'Spine', name: 'Spine' },
  { id: 'Major Ortho', name: 'Major Ortho' },
  { id: 'Plastics', name: 'Plastics' },
  { id: 'Heart', name: 'Heart' },
]

export const drillOptions = [
  { id: 'Stryker cordless driver', name: 'Stryker cordless driver' },
  { id: 'Stryker system 8', name: 'Stryker system 8' },
  { id: 'Stryker MicroAirpower', name: 'Stryker MicroAirpower' },
  { id: 'Stryker TPS', name: 'Stryker TPS' },
  { id: 'Stryker CD4', name: 'Stryker CD4' },
  { id: 'Midas Rex (pneumatic)', name: 'Midas Rex (pneumatic)' },
]

export const positions: { image: string; name: string }[] = [
  {
    image: pos1,
    name: 'Supine',
  },
  {
    image: pos2,
    name: 'Trendelenburg',
  },
  {
    image: pos3,
    name: 'Reverse Trendelenburg',
  },
  {
    image: pos4,
    name: 'Fracture Table',
  },
  {
    image: pos5,
    name: 'Lithotomy',
  },
  {
    image: pos6,
    name: 'Prone',
  },
  {
    image: pos7,
    name: 'Jackknife',
  },
  {
    image: pos8,
    name: "Fowler's",
  },
  {
    image: pos9,
    name: 'Knee-Chest',
  },
  {
    image: pos10,
    name: 'Kidney',
  },
  {
    image: pos11,
    name: 'Lateral',
  },
  {
    image: pos12,
    name: 'Wilson Frame',
  },
]

export const defaultTags: TagCategory[] = [
  'Pack',
  'Gloves',
  'Drapes',
  'Sutures',
  'General Supply',
  'Dressings',
  'Medications',
]

export const consumablesTableHeaders: HeadCell[] = [
  {
    id: 'description',
    label: 'Description',
    numeric: true,
  },
  {
    id: 'catalogNumber',
    label: 'Catalog Number',
    numeric: true,
  },
  {
    id: 'modelNumber',
    label: 'Model Number',
    numeric: true,
  },
  {
    id: 'tags',
    label: 'Tags',
    numeric: true,
  },
  {
    id: 'addMeasurement',
    label: 'Add Measurement',
    numeric: true,
  },
  {
    id: 'actions',
    label: 'ACTIONS',
    numeric: true,
  },
]

export const pascInstrumentTrayOptions: string[] = [
  '5mm 0&30 degree',
  'Anal scope',
  'Arthrex 30-degree scope',
  'Arthrex ACL trays',
  'Arthrex ankle 30 degree 2.7mm scope',
  'Arthrex ankle Distractor',
  'Arthrex Bio-Tenodesis tray',
  'Arthrex camera and light cord',
  'Arthrex Chondro Picks',
  'Arthrex graft prep station set',
  'Arthrex graspers',
  'Arthrex lightcord',
  'Arthrex Retro reconstruction tray',
  'Arthrex shoulder tray',
  'Arthrex video camera',
  'Arthroscopy/laparoscopy 4mm 30-degree scope',
  'Atlantech Graspers',
  'Bariatric graspers',
  'Basin',
  'Batteries',
  'BIOM tray',
  'Bleph',
  'Boogie',
  'Breast bowls',
  'Breast sizers',
  'Breast Tray',
  'Cataract black light handles',
  'Cataract trays',
  'Compaction plier set',
  'Cordless driver',
  'Coupler',
  'Curette set',
  'Cysto tray',
  'D & C Tray',
  'D&C suction tubing',
  'Dilators',
  'Dissecting Tray',
  'Drill bit set',
  'Essure instruments',
  'Face cannulas',
  'Face lift',
  'Fat transfer',
  'Fat transfer cannister',
  'Finger traps',
  'Glass fat transfer cannister',
  'GYN ACMI Hysteroscope',
  'GYN Lap Tray',
  'Hemorriodectomy Tray',
  'Kaiser cataract trays',
  'Kaiser rhino inst',
  'Kaiser surgery tray',
  'Kidney Basins',
  'KLS small hardware removal set',
  'K-wires',
  'Lap Chole Tray',
  'Laparoscopic scissors',
  'Laparoscopy trocars',
  'Lead hand',
  'Light Handles',
  'Lighted retractor',
  'Lipo cord',
  'Lipo&fat transfer',
  'Liver retractor',
  'Laryngoscope handles',
  'Lonestar',
  'Magnet pads',
  'Major Tray',
  'Mallet',
  'Medtronic shaver',
  'Micro instruments',
  'MicroAire power',
  'Mini mandiblualar Tray',
  'Minor Tray',
  'Myringotomy Tray',
  'Oconno Sullivan/blades',
  'Olympus 70-degree',
  'Operative Laparoscopy Tray',
  'Ora cover',
  'Orthro Minor Amputation',
  'Osteotomes',
  'Otoplasty',
  'Plastic Tray',
  'Podiatry Tray',
  'Retina resight',
  'Rhinoplasty Tray',
  'Rhizotomy',
  'Rosa partial and total trays',
  'S&N spider inst',
  'Scope adapters',
  'Septal Nasal Tray',
  'Sigmoid scope',
  'Small bowls',
  'Smith and nephew Dyonics power',
  'Smith and Nephew hip arthroscopy repair tray',
  'Spine drill',
  'Storz & wolf 4mm 30&70 degree',
  'Stryker 4mm 70 degrees',
  'Stryker 5mm 0-degree scope',
  'Stryker hysteroscopy set',
  'Stryker implant extraction set',
  'Stryker laparoscopic instrument bin',
  'Stryker laparoscopic tray',
  'Stryker meniscal repair tray',
  'Stryker microdebrider',
  'Stryker saber drill',
  'Stryker shaver',
  'Stryker small joint instrument set',
  'Stryker small joint scope',
  'Stryker suction irrigation tips',
  'System 6',
  'T & A Adult',
  'T & A Peds',
  'T.T.',
  'Teeth guard',
  'Total knee Tray',
  'Trimano coupler',
  'True clear',
  'Tubal Tray',
  'Vitrectomy tray',
  'Wolf 10mm 90-degree',
  'Wolf 17 and 13inch uretero-reno',
  'Wolf 2.7mm 30 degree/entellus 3.0m',
  'Wolf 4mm 0 degree',
  'Wolf 5mm 0&30degree',
  'Wolf 90-degree scope',
  'Wolf flexible fiberscope',
  'Zimmer patella femoral joint system',
  'Zimmer PKK set',
]

export const instrumentTrayOptions: string[] = [
  'Basic',
  'Burn',
  'Basic Urology',
  'Craniotomy',
  'Special Plastic',
  'Ortho Basic',
  'GYN',
  'Midface',
  'Basic General',
  'Spine',
  'Cardiac',
  'Mandible',
  'Laparotomy',
  'Ortho Fx',
  'ENT',
  'Bookwalter',
  'Neurosurgery',
  'Vascular',
  'Thoracic',
  'Trauma',
  'Pediatric',
  'Hand',
  'Foot & Ankle',
  'Shoulder',
  'Hip',
  'Knee',
]
